import React from 'react';
import SuccessMessage from 'common/SuccessMessage';
import ErrorMessage from 'common/ErrorMessage';

// Refer to:
// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
const getDisplayName = Component => Component.displayName || Component.name || 'Component';

export const withNotification = WrappedComponent => {
  class WithNotification extends React.Component {
    constructor() {
      super();
      this.state = {
        showNotification: false,
        notificationType: "",
        notificationMessage: ""
      };
    }

    onNotificationDismissed() {
      this.setState({showNotification: false, notificationMessage: "", notificationType: ""});
    }

    showSuccessNotification(notificationMessage) {
      this.setState({showNotification: true, notificationType: "success", notificationMessage});
    }

    showErrorNotification(notificationMessage) {
      this.setState({showNotification: true, notificationType: "error", notificationMessage});
    }

    getNotification() {
      if ( !this.state.showNotification ) return null;
      if ( this.state.notificationType === "success" ) {
        return (
          <SuccessMessage
            message={this.state.notificationMessage}
            onDismiss={this.onNotificationDismissed.bind(this)}
          />
        );
      }
      else if ( this.state.notificationType === "error") {
        return (
          <ErrorMessage
            message={this.state.notificationMessage}
            onDismiss={this.onNotificationDismissed.bind(this)}
          />
        );
      }
      return null;
    }

    renderNotification() {
      // the alert div must exist when the page is loaded in order for
      // the screen readers to read out any messages
      return <div role="alert">{this.getNotification()}</div>
    }

    render() {
      return (
        <WrappedComponent
          notification={{
            render: this.renderNotification.bind(this),
            dismiss: this.onNotificationDismissed.bind(this),
            success: this.showSuccessNotification.bind(this),
            error: this.showErrorNotification.bind(this),
            isVisible: this.state.showNotification
          }}
          {...this.props}
        />
      );
    }
  }

  WithNotification.displayName = `WithNotification(${getDisplayName(WrappedComponent)})`;
  return WithNotification;
}
